module.exports = __webpack_public_path__ + "img/north-macedonia.a21fdc4d.svg";